import { NavItem } from '@cube3/cubicle/src/core/atoms/Navigation/NavItem';
import React, { useCallback, useContext } from 'react';
import { DragAndDropContext } from '../../ContentPane/ContentTree/items/dragAndDrop/Draggable';
import {
  NavGroup,
  NavGroupProps
} from '@cube3/cubicle/src/core/atoms/Navigation/NavGroup';
import { useCurrentWorkspace } from '@cube3/state/src/redux/components/Administration/withCurrentWorkspace';
import { useResourceList__ALPHA } from '@cube3/state/src/redux/components/Hooks/useResourceList';

export const DroppableNavGroup = <M extends string = string>(props: NavGroupProps<M>) => {
  const dropTarget = useContext(DragAndDropContext);

  const [workspaceId] = useCurrentWorkspace();
  const { first: library } = useResourceList__ALPHA({
    resourceType: 'workspace',
    resourceId: workspaceId,
    edgeType: 'library',
    edgeLabel: 'libraries'
  });

  const renderNavItem = useCallback(
    (item: NavItem, config) => {
      const datasetId = item.linkTitle.toLocaleLowerCase();
      const droppable = ['projects', 'favorites', 'library', 'bin'].includes(
        datasetId
      );
      const isDropActive =
        droppable &&
        dropTarget &&
        dropTarget.type === 'navigation' &&
        dropTarget.id === datasetId;

      return (
        <NavItem
          key={item.linkTitle}
          item={
            droppable
              ? {
                ...item,
                dataset: {
                  id: datasetId,
                  type: 'navigation',
                  pathname:
                    datasetId === 'library'
                      ? (item.url as string).replace('libraries', 'library') +
                      '/' +
                      library?.id
                      : item.url
                }
              }
              : item
          }
          {...config}
          isDropActive={isDropActive}
        />
      );
    },
    [dropTarget, library]
  );

  return <NavGroup {...props} renderNavItem={renderNavItem} />;
};
